<template>
  <div class="createCurriculumSystem">
    <el-steps :active="active" finish-status="success" style="padding: 0 20px" size="mini">
      <el-step title="基本信息">基本信息</el-step>
      <el-step title="上传附件">上传附件</el-step>
      <el-step title="提交审核">提交审核</el-step>
    </el-steps>
    <el-form
      class="form-style"
      label-width="120px"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      v-show="active === 0"
    >
      <el-form-item label="课程名称" required prop="curriculum_name">
        <el-input
          v-model="ruleForm.curriculum_name"
          placeholder="请输入名称"
          style="width: 300px"
        ></el-input>
      </el-form-item>
      <el-form-item label="课程科目" required prop="subject_id">
        <el-select
          v-model="ruleForm.subject_id"
          placeholder="请选择"
          style="width: 300px"
        >
          <el-option
            :label="item.name"
            :value="item.id"
            v-for="(item, index) of subjectList"
            :key="index"
          ></el-option>
        </el-select>
        <el-button
          type="primary"
          style="margin-left: 20px"
          @click="handleAddSubject"
          >新增科目</el-button
        >
      </el-form-item>
      <el-form-item label="课程类别" required prop="teaching_type">
        <el-select
          v-model="ruleForm.teaching_type"
          placeholder="请选择"
          style="width: 300px"
        >
          <el-option label="面授课" value="1"></el-option>
          <el-option label="直播课" value="2"></el-option>
          <el-option label="录播课" value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="课程次数" required prop="number_of_courses">
        <el-input-number
          v-model="ruleForm.number_of_courses"
          :precision="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="排序号" required prop="sort_num">
        <el-input-number
          v-model="ruleForm.sort_num"
          :precision="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="课程资料" required>
        <el-upload
          action=""
          :http-request="uploadFile"
          :on-remove="
            (file, fileList) => handleRemove(file, fileList, 'curriculum_url')
          "
          :on-change="
            (file, fileList) =>
              handleChangeFile(file, fileList, 'curriculum_url')
          "
          :auto-upload="false"
          multiple
          :file-list="ruleForm.curriculum_url"
          style="width: 300px"
        >
          <el-button size="small" type="primary" plain>点击上传</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <el-form class="form-style" label-width="0px" v-show="active === 1">
      <el-form-item>
        <div
          v-for="(item, index) of ruleForm.curriculum_classes_list"
          :key="index"
          class="upload"
        >
          <div class="uploadList">
            <span style="color: red">*</span>
            第{{ index + 1 }}讲：<el-input
              v-model="item.name"
              placeholder="请输入名称"
              style="width: 150px"
              size="small"
            ></el-input>
          </div>
          <div class="uploadList">
            课程视频1：<el-upload
              action=""
              :limit="1"
              :http-request="uploadFile"
              :on-remove="
                (file, fileList) =>
                  handleRemove(file, fileList, 'video_url_first', index)
              "
              :on-change="
                (file, fileList) =>
                  handleChangeFile(file, fileList, 'video_url_first', index)
              "
              :auto-upload="false"
              :file-list="item.video_url_first || []"
              style="width: 150px"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </div>
          <div class="uploadList">
            课程视频2：<el-upload
              action=""
              :limit="1"
              :http-request="uploadFile"
              :on-remove="
                (file, fileList) =>
                  handleRemove(file, fileList, 'video_url_second', index)
              "
              :on-change="
                (file, fileList) =>
                  handleChangeFile(file, fileList, 'video_url_second', index)
              "
              :auto-upload="false"
              :file-list="item.video_url_second || []"
              style="width: 150px"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </div>
          <div class="uploadList">
            讲义：
            <el-input
              v-model="item.teaching_materials_url"
              placeholder="请输入url"
              style="width: 150px"
              size="small"
            ></el-input>
          </div>
          <div class="uploadList">
            <span style="color: red">*</span>
            PPT：
            <el-input
              v-model="item.ppt_url"
              placeholder="请输入url"
              style="width: 150px"
              size="small"
            ></el-input>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div class="section" v-show="active === 3">
      <h2>提交成功</h2>
      <div class="btn">
        <el-button type="success" @click="quit">返回</el-button>
      </div>
    </div>
    <el-dialog title="添加科目" :visible.sync="dialogVisible">
      <el-form
        class="form-style"
        label-width="120px"
        :model="subjectRuleForm"
        :rules="subjectRules"
        ref="subjectRuleForm"
      >
        <el-form-item label="名称" required prop="subject_name">
          <el-input
            v-model="subjectRuleForm.subject_name"
            placeholder="请输入名称"
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序号" required prop="sort_num">
          <el-input-number
            v-model="subjectRuleForm.sort_num"
            :precision="0"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="quitAddSubject('subjectRuleForm')">取 消</el-button>
        <el-button type="primary" @click="addSubject('subjectRuleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <div class="btn" v-if="active !== 3">
      <el-button @click="--active" type="primary" v-if="active !== 0"
        >上一步</el-button
      >
      <el-button @click="next('ruleForm')" type="primary">下一步</el-button>
      <el-button @click="quit">取消</el-button>
    </div>
  </div>
</template>

<script>
import { getUserSubjectList } from "@/api/user";
import { addSubject, addCurriculum } from "@/api/educational";
import uploadFile from "@/config/uploadFile";
export default {
  name: "createCurriculumSystem",
  data() {
    return {
      uploadFileTime: false,
      dialogVisible: false,
      active: 1,
      subjectList: [],
      ruleForm: {
        subject_id: "",
        teaching_type: "",
        number_of_courses: 1,
        sort_num: 1,
        curriculum_name: "",
        curriculum_url: [],
        curriculum_classes_list: [{}],
      },
      subjectRuleForm: {
        subject_name: "",
        sort_num: "",
      },
      rules: {
        curriculum_name: [
          {
            required: true,
            message: "请输入课程名称",
            trigger: "blur",
          },
          {
            required: true,
            message: "请输入课程名称",
            trigger: "change",
          },
        ],
        teaching_type: [
          { required: true, message: "请选择类别", trigger: "change" },
        ],
        number_of_courses: [
          { required: true, message: "请输入课程次数", trigger: "change" },
        ],
        sort_num: [
          { required: true, message: "请输入排序号", trigger: "change" },
        ],
        subject_id: [
          { required: true, message: "请选择科目", trigger: "change" },
        ],
      },
      subjectRules: {
        subject_name: [
          { required: true, message: "请输入名称", trigger: "blur" },
        ],
        sort_num: [
          { required: true, message: "请选择活类别", trigger: "change" },
        ],
      },
    };
  },
  mounted() {
    this.getUserSubjectList();
  },
  methods: {
    handleAddSubject() {
      this.dialogVisible = true;
    },
    // 获取科目
    getUserSubjectList() {
      getUserSubjectList().then((res) => {
        this.subjectList = res.base_platform.concat(res.mechanism_platform);
      });
    },
    // 添加科目
    addSubject(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addSubject({
            subject_name: this.subjectRuleForm.subject_name,
            sort_num: this.subjectRuleForm.sort_num,
            subject_state: 2,
          }).then((res) => {
            this.$message.success("添加科目成功");
            this.ruleForm.subject_id = res.subject_id;
            this.getUserSubjectList();
            this.dialogVisible = false;
          });
        }
      });
    },
    quitAddSubject(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },
    // 下一步
    next(formName) {
      if (this.active === 0) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.ruleForm.curriculum_classes_list = [];
            for (let i = 0; i < Number(this.ruleForm.number_of_courses); i++) {
              this.ruleForm.curriculum_classes_list.push({
                name: "",
                sort_num: i + 1,
                video_url_first: [],
                video_url_second: [],
                teaching_materials_url: "",
                ppt_url: "",
              });
            }
            if (!this.ruleForm.curriculum_url.length) {
              this.$message.warning("请上传课程资料");
              return;
            }
            ++this.active;
          }
        });
      } else if (this.active === 1) {
        for (let i = 0; i < this.ruleForm.curriculum_classes_list.length; i++) {
          if (!this.ruleForm.curriculum_classes_list[i].name) {
            this.$message.warning(`请填写第${i + 1}讲课程名称`);
            return;
          }
          if (!this.ruleForm.curriculum_classes_list[i].ppt_url) {
            this.$message.warning(`请填写第${i + 1}讲PPT`);
            return;
          }
        }
        let fileList = [];
        for (let i = 0; i < this.ruleForm.curriculum_classes_list.length; i++) {
          fileList[i] = {};
          fileList[i].sort_num = i + 1;
          fileList[i].name = this.ruleForm.curriculum_classes_list[i].name;
          fileList[i].video_url_first = this.ruleForm.curriculum_classes_list[i]
            .video_url_first[0]
            ? this.ruleForm.curriculum_classes_list[i].video_url_first[0].url
            : "";
          fileList[i].video_url_second = this.ruleForm.curriculum_classes_list[
            i
          ].video_url_second[0]
            ? this.ruleForm.curriculum_classes_list[i].video_url_second[0].url
            : "";
          fileList[i].teaching_materials_url = this.ruleForm.curriculum_classes_list[i].teaching_materials_url
          fileList[i].ppt_url = this.ruleForm.curriculum_classes_list[i].ppt_url;
        }
        addCurriculum({
          subject_id: this.ruleForm.subject_id,
          teaching_type: this.ruleForm.teaching_type,
          number_of_courses: this.ruleForm.number_of_courses,
          sort_num: this.ruleForm.sort_num,
          curriculum_name: this.ruleForm.curriculum_name,
          curriculum_url: JSON.stringify(this.ruleForm.curriculum_url),
          curriculum_classes_list: JSON.stringify(fileList),
        },
        true
        ).then(() => {
          this.active += 2;
        });
      }
    },
    quit() {
      this.$router.push({ name: "own-class-management" });
    },
    uploadFile() {},
    handleRemove(file, fileList, status, index) {
      if (status === "curriculum_url") {
        this.ruleForm.curriculum_url = fileList;
      } else {
        this.ruleForm.curriculum_classes_list[index][status] = fileList;
      }
    },
    async handleChangeFile(file, fileList, status, index) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList, status, index);
      }
    },
    async uploadFileOss(list, status, index) {
      this.uploadFileTime = true;
      await uploadFile(list,this.$store.state.user.userInfo.code).then((res) => {
        if (status === "curriculum_url") {
          this.ruleForm.curriculum_url = res;
        } else {
          this.ruleForm.curriculum_classes_list[index][status] = res;
        }
        this.uploadFileTime = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.createCurriculumSystem {
  width: 100%;
  background-color: #fff;
  box-sizing: border-box;
  padding: 20px;
  .btn {
    margin: 30px 0 20px 0;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .upload {
    display: flex;
    justify-content: space-around;
    margin-top: 20px;
    width: 100%;
    .uploadList {
      display: flex;
      margin-left: 20px;
    }
  }
  .section {
    box-sizing: border-box;
    height: 300px;
    margin: 30px 50px;
    padding: 60px 0 0 0;
    background-color: #fff;
    text-align: center;
    h2 {
      font-size: 24px;
      font-weight: bold;
      color: #67c23a;
      margin-bottom: 10px;
    }
    li {
      list-style: square;
      line-height: 40px;
      font-size: 16px;
    }
    .btn {
      margin-top: 20px;
      font-size: 16px;
    }
  }
}
</style>
